import styled from "styled-components";

export const CompanyDataFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  span {
    font-size: 16px;
    font-weight: 700;
  }
`;

export const CompanyDataFormInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  > div {
    max-width: 18.75rem;
    width: 100%;
  }
  > span{
     display: flex;
  }
`;

export const InstituicaoInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  label {
    font-size: 0.875rem;
    font-weight: 400;

    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  div {
    height: 43px;
  }

  span {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.danger};
  }
`;

export const Select = styled.select`
  width: 100%;
  max-height: 2.6875rem;
  height: 100%;
  padding: 0.625rem 0.75rem;
  background-color: ${({ theme }) => theme.colors['bg-input-color']};
  border: 1px solid ${({ theme }) => theme.colors['text-primary']};
  border-radius: 4px;

  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ErrorMessage = styled.span`
  margin-top: 2rem;
  color: red;
`;

export const Div = styled.div`
position: relative;
transform: translateY(-377%);
margin-left: 24.1rem;
`;

export const WarnMessage = styled.span`
  font-size: 13.5px !important;
  color: var(--color-danger);
  margin-left: 0.2rem;
  font-weight: 700;
  border-bottom: 1px solid ${({ theme }) => theme.colors['text-primary']};
  
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1.5rem;
  text-align: center;
`;

export const IconContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const SearchIcon = styled.div`
  font-size: 3rem;
  opacity: 0.7;
  filter: grayscale(100%);
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2rem;
  width: 100%;
`;

export const PrimaryMessage = styled.p`
  font-size: 16px;
  color: var(--text-primary);
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
`;

export const SecondaryMessage = styled.p`
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
`;

export const WarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background-color: #fef5e7;
  border: 1px solid #f6ad55;
  border-radius: 8px;
  border-left: 4px solid #ed8936;
`;

export const WarningIcon = styled.span`
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
`;

export const WarningText = styled.span`
  font-size: 13px;
  color: #744210;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;
  
  strong {
    font-weight: 700;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  width: 100%;
  max-width: 400px;
`;

const BaseButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
  min-width: 140px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background-color: transparent;
  color: var(--color-text-secondary, #4a5568);
  border-color: var(--color-border, #e2e8f0);
  
  &:hover {
    background-color: var(--color-gray-50, #f7fafc);
    border-color: var(--color-border-hover, #cbd5e0);
  }
`;

export const PrimaryButton = styled(BaseButton)`
  background-color: var(--color-primary, #3182ce);
  color: white;
  border-color: var(--color-primary, #3182ce);
  
  &:hover {
    background-color: var(--color-primary-hover, #2c5aa0);
    border-color: var(--color-primary-hover, #2c5aa0);
  }
`;
